import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useCampaignTranslations = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      placeholder: t("campaignPicker_placeholder", {
        defaultValue: "No campaign",
      }),
      searchPlaceholder: t("campaignPicker_search_placeholder", {
        defaultValue: "Search or create new campaign",
      }),
      defaultBadgeLabel: t("campaignPicker_default_badge_label", {
        defaultValue: "Default",
      }),
      createOptionLabel: (query: string): string =>
        t("campaignPicker_create_option_label", {
          query,
          defaultValue: `Create '${query}'`,
        }),
      creatingLabel: t("campaignPicker_creating_label", {
        defaultValue: "Creating campaign…",
      }),
      noCampaignsLabel: t("campaignPicker_no_campaigns_label", {
        defaultValue: "No campaigns available yet",
      }),
      label: t("campaignPicker_label", { defaultValue: "Campaign" }),
      subLabel: t("campaignPicker_sub_label", {
        defaultValue:
          "Group your links and banners by campaigns to compare performance",
      }),
      searchLoadingLabel: t("campaignPicker_search_loading_label", {
        defaultValue: "Searching campaigns…",
      }),
      duplicateNameError: t("campaignPicker_duplicate_name_error", {
        defaultValue:
          "We cannot create the new campaign. Please try again later.",
      }),
      emptyNameError: t("campaignPicker_empty_name_error", {
        defaultValue: "Campaign name must not be empty.",
      }),
    }),
    [t],
  );
};

export type CampaignPickerTranslations = ReturnType<
  typeof useCampaignTranslations
>;
